import Multiplier from "./Multiplier";
export default Multiplier